const VIEW_TODO_DETAIL = "todo-detail";
const KEY = "weektodo";

let current = null;
const listeners = new Set();

function notify() {
  listeners.forEach((fn) => {
    try {
      fn(current);
    } catch (e) {
      console.error(e);
    }
  });
}

function readState(state) {
  if (!state || !state[KEY]) return null;
  const nav = state[KEY];
  if (nav.view !== VIEW_TODO_DETAIL) return null;
  if (nav.listId == null || nav.index == null) return null;
  return { listId: String(nav.listId), index: Number(nav.index) };
}

function onPopState(event) {
  current = readState(event.state);
  notify();
}

let listening = false;

function ensureListen() {
  if (listening || typeof window === "undefined") return;
  listening = true;
  window.addEventListener("popstate", onPopState);
  current = readState(window.history.state);
}

function isPhoneNav() {
  if (typeof window === "undefined") return false;
  return window.innerWidth < 768;
}

/**
 * 手机端打开任务详情（写入 history，支持系统右滑/后退）。
 * @returns {boolean} 是否已由页面导航接手（false 时调用方应走 PC 弹窗）
 */
function openTodoDetail({ listId, index }) {
  ensureListen();
  if (!isPhoneNav()) return false;
  const payload = {
    listId: String(listId),
    index: Number(index),
  };
  const state = { [KEY]: { view: VIEW_TODO_DETAIL, ...payload } };
  const url =
    typeof window.location !== "undefined"
      ? `${window.location.pathname}${window.location.search}#todo/${payload.listId}/${payload.index}`
      : "";
  window.history.pushState(state, "", url || undefined);
  current = payload;
  notify();
  return true;
}

function closeTodoDetail() {
  ensureListen();
  if (!current) return;
  window.history.back();
}

/** 不入历史后退栈，直接清掉详情（数据失效等） */
function clearTodoDetail() {
  ensureListen();
  if (!current) return;
  current = null;
  if (typeof window !== "undefined") {
    const url = `${window.location.pathname}${window.location.search}`;
    window.history.replaceState({}, "", url);
  }
  notify();
}

function getTodoDetail() {
  ensureListen();
  return current;
}

function subscribeTodoDetail(listener) {
  ensureListen();
  listeners.add(listener);
  listener(current);
  return () => listeners.delete(listener);
}

module.exports = {
  VIEW_TODO_DETAIL,
  isPhoneNav,
  openTodoDetail,
  closeTodoDetail,
  clearTodoDetail,
  getTodoDetail,
  subscribeTodoDetail,
};
